/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import useEventRouting from "hooks/useEventRouting";
import useTryCatch from "hooks/useTryCatch";
import { getNotifications, setNotificationAsSeen } from "lib/notificationsApi";
import { useEffect, useState } from "react";
import ROUTES from "routes";
import { useEnvs } from "state/EnvironmentsContext/EnvContext";
import { useGlobal } from "state/GeneralContext";

const useNotifications = (userId) => {
  const { navigateWithEvent, eventId } = useEventRouting();
  const { setHasNotifications } = useGlobal();
  const [notifications, setNotifications] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetched, setFetched] = useState(false);
  const [isError, setError] = useState(false);

  const NOTIFICATION_ACTIONS = {
    user_new_trip_added: ROUTES.dashboard.base,
    default: ROUTES.dashboard.base,
  };
  const getNotificationAction = (notification) => {
    return (
      NOTIFICATION_ACTIONS[notification.action] || NOTIFICATION_ACTIONS.default
    );
  };

  const handleTapToView = useTryCatch(
    async (notification) => {
      const { data, ok } = await setNotificationAsSeen(
        userId,
        notification.id,
        eventId,
      );
      if (ok) {
        setHasNotifications(data.unseen_notifications);
        navigateWithEvent(getNotificationAction(notification));
      }
    },
    {
      onError: () => setError(true),
    },
  );
  const { environment: ENVIRONMENT } = useEnvs();
  const fetchNotifications = useTryCatch(
    async () => {
      if (!userId) {
        if (ENVIRONMENT !== "production") {
          console.error("No user id was given");
        }
        setNotifications([]);
        setFetched(true);
      }
      const { data, ok } = await getNotifications(userId, eventId);
      if (ok) {
        setNotifications(data);
        setFetched(true);
      }
    },
    {
      onError: () => setError(true),
      setLoading: setIsLoading,
    },
  );
  useEffect(() => {
    fetchNotifications();
  }, []);
  return { notifications, isLoading, isError, isFetched, handleTapToView };
};

export default useNotifications;
